<template>
  <multiselect
    :value="value"
    @input="sendValue"
    :options="options"
    :placeholder="$t('selectExam.PLACEHOLDER')"
    :selectLabel="$t('selectExam.label.SELECT')"
    :deselectLabel="$t('selectExam.label.DESELECT')"
    :customLabel="getLabel"
    track-by="id"
    :close-on-select="true">
    <template slot="singleLabel" slot-scope="{ option }">
      <span>{{ option.name }} {{ date2local(option.start) }}</span>
    </template>
    <template slot="noOptions">{{ $t('selectExam.NO_OPTIONS') }}</template>
    <template slot="option" slot-scope="props">
      <div class="option__desc">
        <span class="option__title">{{ props.option.name }} {{ date2local(props.option.start) }}</span>
      </div>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { date2local } from '@/utils/utils.format'

export default {
  name: 'SelectExam',
  props: {
    options: [Array],
    value: [Object]
  },
  components: {
    Multiselect
  },
  methods: {
    sendValue (option) {
      this.$emit('input', option)
    },
    getLabel (option) {
      const { start } = option
      const startString = new Date(start).toLocaleString()
      return `${option.name} ${startString}`
    },
    date2local
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>

@import "~@/styles/base.scss";

.multiselect {
  margin: $input-margin;
}

</style>
